export default __webpack_public_path__ + "static/media/dress.ce76f103.svg";